import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * Replica `.bdg.bdg-ok` del diseño: pastilla verde de 11px/600 con fondo, borde y un punto de color a la
 * izquierda (ej. "Recomendada" en `DecisionIngreso`). Convive con `Badge`, que es la pastilla de contorno
 * que usan las demás pantallas.
 */
export const BadgeSuccess = ({ children }: { children: ReactNode }) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      px: "10px",
      py: "3px",
      borderRadius: 999,
      border: "1px solid #C9F0D6",
      bgcolor: "#ECFDF3",
      verticalAlign: "middle",
      whiteSpace: "nowrap",
    }}
  >
    <Box component="span" sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "#16A34A", flexShrink: 0 }} />
    <Typography
      component="span"
      sx={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.01em", lineHeight: 1.4, color: "#15803D" }}
    >
      {children}
    </Typography>
  </Box>
);
